import statistics from '@/locales/es/statistics/statistics.locales';

export default {
    ...statistics,
};
